import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import { useTimeClockStore } from 'store/useTimeClockStore';
import http from 'utils/http';

export interface IClockOut {
  user_id: string;
  latitude: number | null;
  longitude: number | null;
  speed?: number;
  timezone?: string;
  clockout_image?: any;
  mileage?: number;
  offset?: any;
  clock_out_time?: string;
  notes?: string;
  caption?: string;
  meal_break_compliance?: boolean;
  rest_break_compliance?: boolean;
  meal_break_reason?: any;
  rest_break_reason?: any;
  custom_fields?: any;
}

const clockOut = (postData: IClockOut) => {
  if (postData?.clockout_image) {
    const postFormData: any = new FormData();

    for (const key in postData) {
      // @ts-ignore
      let value: any = postData[key];

      if (key === 'custom_fields') {
        value = JSON.stringify(postData[key]);
      }
      postFormData.append(`${key}`, value);
    }
    return http('multipart').post(endpoints.timeClock.clockOut, postFormData);
  }
  return http().post(endpoints.timeClock.clockOut, postData);
};

export function useClockOut() {
  const addTimeClockDetails = useTimeClockStore(state => state.addTimeClockDetails);

  return useMutation({
    mutationFn: clockOut,
    onSuccess: () => {
      addTimeClockDetails(null);
    },
  });
}
